import { render, staticRenderFns } from "./PlotTreeMapping.vue?vue&type=template&id=e1164b90&scoped=true"
import script from "./PlotTreeMapping.vue?vue&type=script&lang=js"
export * from "./PlotTreeMapping.vue?vue&type=script&lang=js"
import style0 from "./PlotTreeMapping.vue?vue&type=style&index=0&id=e1164b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1164b90",
  null
  
)

export default component.exports